import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/UI/Box';
import Chip from '@/components/UI/Chip';
import type { MemberType, PeopleFilter } from './member-type';

export type { MemberType, PeopleFilter } from './member-type';

const memberTypes: ReadonlyArray<{
  kind: MemberType;
  label: string;
}> = [
  { kind: 'participant', label: 'Participants' },
  { kind: 'non_participant', label: 'Non Participants' },
];

const singularMemberTypes: ReadonlyArray<{
  kind: MemberType;
  label: string;
}> = [
  { kind: 'participant', label: 'Participant' },
  { kind: 'non_participant', label: 'Non Participant' },
];

const peopleFilters: ReadonlyArray<{ kind: PeopleFilter; label: string }> = [
  { kind: 'all', label: 'All' },
  ...memberTypes,
];

export default function PeopleFilterSelector({
  value,
  onValueChange,
}: {
  value: PeopleFilter;
  onValueChange: (value: PeopleFilter) => void;
}) {
  return (
    <KindSelector
      kinds={peopleFilters}
      value={value}
      onValueChange={onValueChange}
    />
  );
}

export function MemberTypeSelector({
  labelForm = 'plural',
  testIDPrefix = 'PeopleFilter',
  value,
  onValueChange,
}: {
  labelForm?: 'plural' | 'singular';
  testIDPrefix?: string;
  value: MemberType;
  onValueChange: (value: MemberType) => void;
}) {
  return (
    <KindSelector
      kinds={labelForm === 'singular' ? singularMemberTypes : memberTypes}
      testIDPrefix={testIDPrefix}
      value={value}
      onValueChange={onValueChange}
    />
  );
}

function KindSelector<Kind extends PeopleFilter>({
  kinds,
  testIDPrefix = 'PeopleFilter',
  value,
  onValueChange,
}: {
  kinds: ReadonlyArray<{ kind: Kind; label: string }>;
  testIDPrefix?: string;
  value: Kind;
  onValueChange: (value: Kind) => void;
}) {
  return (
    <Box accessibilityRole="radiogroup" direction="horizontal" space="sm" wrap>
      {kinds.map(({ kind, label }) => (
        <Chip
          key={kind}
          label={label}
          style={styles.chip}
          testID={`${testIDPrefix}-${kind}`}
          value={value === kind}
          onValueChange={() => onValueChange(kind)}
        />
      ))}
    </Box>
  );
}

const styles = StyleSheet.create((theme) => ({
  chip: {
    minHeight: theme.size(9),
    paddingVertical: 0,
  },
}));
